import React from "react";
import Header from "../Components/Header";
import Header1 from "../Components/Header1";
import Upload from "../Components/Upload";
import Footer from "../Components/Footer";
import Clientlogo from "../Components/Clientlogo";

const Page1 = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center">
      {/* <div className="w-full flex justify-center sticky top-0 bg-white z-10">
        <section className="2xl:container w-full flex">
          <Header />
        </section>
      </div> */}
      <div className="w-full bg-white flex justify-center sticky top-0 bg-white z-20 border-b-[1px] border-gray-200">
        <div className="2xl:container w-full ">
          <Header />
        </div>
      </div>
      <div className="w-full bg-404A52 flex justify-center sticky sm:top-20 z-10">
        <section className="2xl:container flex w-full sticky top-10">
          <Header1 />
        </section>
      </div>
      <div className="w-full flex justify-center flex-col items-center mb-auto">
        <div className="w-full 2xl:container">
          <Upload />
        </div>
        <div className="w-full flex justify-center">
          <Clientlogo />
        </div>
      </div>
      <div className="w-full mt-auto">
        <Footer />
      </div>
    </div>
  );
};

export default Page1;
